{
  "app": {
    "tittel": "Selskapsportal for fjernvarme",
    "language": "Språk",
    "language_nb-NO": "Bokmål",
    "language_nn-NO": "Nynorsk"
  },
  "button": {
    "login": "Logg inn",
    "next": "Neste",
    "back": "Tilbake",
    "open": "Åpne",
    "back-to-frontpage": "Tilbake til forsiden",
    "saving": "Lagrer",
    "save": "Lagre",
    "cancel": "Avbryt"
  },
  "generisk": {
    "laster": "Laster...",
    "feil": "Noe feil har skjedd, vennligst prøv igjen senere."
  },
  "components": {
    "nyttige-lenker": "Nyttige lenker",
    "async-suggestions": {
      "laster-aria-label": "Laster søkeresultater",
      "søk-aria-label": "Søk",
      "ingen-resultat": "Ingen resultat",
      "ingen-streng": "Start å skrive for å søke"
    }
  },
  "eksterneLenker": {
    "forskriftOmNorgespris": {
      "url": "https://lovdata.no/dokument/SF/forskrift/2025-09-08-1792",
      "label": "Forskrift om Norgespris"
    },
    "lovOmNorgespris": {
      "url": "https://lovdata.no/dokument/NL/lov/2025-06-20-44",
      "label": "Lov om Norgespris og strømstønad til husholdninger"
    },
    "avtalevilkaar": {
      "url": "/vilkår",
      "label": "Avtalevilkår"
    },
    "merOmNorgespris": {
      "url": "https://www.nve.no/energi/energisystem/fjernvarme/norgespris-og-stroemstoette-for-fjernvarme/",
      "label": "Les mer om Norgespris"
    },
    "spmOgSvarNve": {
      "url": "https://www.nve.no/energi/energisystem/fjernvarme/norgespris-og-stroemstoette-for-fjernvarme/spoersmaal-og-svar-norgespris-og-stroemstoette-for-fjernvarme/",
      "label": "Spørsmål og svar til Norgespris og strømstøtte for fjernvarme"
    },
    "enovaSvarer": {
      "label": "Enova Svarer",
      "url": "https://www.enova.no/nb/om-oss/hvem-er-enova/kontakt-oss"
    },
    "nve": {
      "label": "www.nve.no",
      "url": "https://nve.no/"
    },
    "cookies": {
      "label": "Personvern og cookies",
      "url": "https://www.enova.no/nb/om-oss/hvem-er-enova/prinsipper-etterlevelse/datahandtering"
    },
    "tilgjengelighetserklæring": {
      "label": "Tilgjengelighetserklæring",
      "url": "https://uustatus.no/nb/erklaringer/publisert/afe7c36c-a37b-4093-be92-821468ae6c17"
    },
    "kundestotte": {
      "label": "Trenger du hjelp eller har spørsmål?",
      "url": "/kundestøtte"
    },
    "altinn-roller": {
      "label": "Hvordan tildele tilgangspakke i Altinn",
      "url": "https://info.altinn.no/hjelp/ny-tilgangsstyring/tilgangspakker/via-menypunktet-fullmakter/"
    },
    "veiledning": {
      "url": "/veiledning"
    }
  },
  "selskap-header": {
    "tittel": "Hei, {{context}}",
    "bytt-selskap": "Bytt selskap",
    "beskrivelse": "Her kan du se bestillinger av Norgepris gjort av dine kunder.",
    "bytt-valgt-aktor": "Bytt valgt selskap"
  },
  "valideringsProblem": {
    "tittel": "{{context}} feil oppdaget",
    "vis-mer": "Vis mer",
    "dialog-tittel": "Valideringsfeil"
  },
  "pages": {
    "dokumentasjon": {
      "actions": {
        "last-ned-filspesifikasjon": "Last ned spesifikasjon",
        "last-ned-eksempel-fil": "Last ned CSV eksempelfil",
        "last-ned-eksempel-fil-for-windows": "Excel for Windows",
        "last-ned-eksempel-fil-for-mac": "Excel eller Numbers for Mac",
        "last-ned-eksempel-fil-for-365": "Microsoft 365 / Excel på nett",
        "last-ned-eksempel-fil-for-google": "Google Regneark",
        "last-ned-eksempel-fil-for-libre": "LibreOffice / OpenOffice",
        "last-ned-eksempel-fil-for-andre": "Vet ikke / andre",
        "veiledning": "Veiledning"
      },
      "lenker": {
        "tittel": "Teknisk dokumentasjon",
        "avtale-eksport": "Filspesifikasjon for Norgespris avtaler",
        "innrapportering": "Filspesifikasjon for målerdata registrering",
        "test-innrapportering": "Testverktøy for innrapportering av målerdata"
      }
    },
    "landing": {
      "ingress": "Administrer dine kunders Norgespris avtaler og rapportere målerdata.",
      "button.logginn": "Logg inn",
      "ikke-aapnet-enda": {
        "tittel": "Selskapsportal for fjernvarme åpner 05. Oktober",
        "beskrivelse": "Fra 05. Oktober kan du hente Norgespris avtaler for dine kunder ved å logge inn på denne siden. Les om ordningen på NVE sine nettsider. Lanseringen var opprinnelig planlagt til 1. oktober, men er utsatt til 5. oktober.",
        "url-tittel": "Norgespris og strømstøtte for fjernvarme"
      },
      "paa-vegne-av": {
        "tittel": "Logg inn på vegne av fjernvarmeselskap?",
        "beskrivelse": "For å kunne administrere bestillinger og rapportere målerdata på vegne av et fjernvarme/nærvarmeselskap, må man ha tilgangspakken <Uthevd>Tilskudd, Støtte og Erstatning</Uthevd>. Denne erstatter rollene <Uthevd>Energi, miljø og klima</Uthevd> og <Uthevd>Utfyller/innsender</Uthevd> i Altinn. Tilgangen du tidligere fikk via disse rollene vil fortsette å fungere til 31.12.2026, men de vil ikke kunne tildeles etter 15.06.2026."
      },
      "kundeportal": {
        "tittel": "Bestille Norgespris",
        "beskrivelse": "Ønsker du å bestille Norgespris for fjernvarme?",
        "lenke": "Gå til kundeportalen"
      },
      "button": {
        "logg-inn": "Logg inn"
      },
      "hjelpetekst-bilde": "Illustrasjon som viser et nabolag varmet av fjernvarme"
    },
    "velg-selskap": {
      "tittel": "Velg selskap",
      "beskrivelse": "For å kunne administrere bestillinger og rapportere målerdata på vegne av et fjernvarme/nærvarmeselskap, må man ha tilgangspakken <Uthevd>Tilskudd, Støtte og Erstatning</Uthevd>. Denne erstatter rollene <Uthevd>Energi, miljø og klima</Uthevd> og <Uthevd>Utfyller/innsender</Uthevd> i Altinn. Tilgangen du tidligere fikk via disse rollene vil fortsette å fungere til 31.12.2026, men de vil ikke kunne tildeles etter 15.06.2026.",
      "form": {
        "label": "Velg selskap",
        "velg": "Velg",
        "autentiserer": "Sjekker at du har riktige tilganger til selskap...",
        "autentiser-mislyktes": "Innlogging med organisasjonsnummer {{orgnr}} mislyktes. Sjekk at du har riktig tilgangspakke i Altinn.",
        "feil": {
          "pakrevd": "Du må velge en selskap for å fortsette.",
          "ingen-tilganger": "Ingen tilganger funnet for denne brukeren.",
          "laste-feil": "Det oppstod en feil ved lasting av selskaper. Vennligst prøv igjen senere."
        }
      }
    },
    "bestillinger": {
      "tittel": "Bestillinger",
      "beskrivelse": "Her kan du se og administrere alle dine bestillinger for Norgespris.",
      "ingen-bestillinger": "Dere har ingen bestillinger.",
      "ingen-selskap": "Ingen selskap valgt.",
      "laste-feil": "Kunne ikke hente bestillinger, vennligst prøv igjen senere.",
      "aktive-avtaler-tag": "Aktive avtaler",
      "eksporter-knapp": "Eksporter",
      "fil-sist-oppdatert": "Fil sist oppdatert",
      "fil-sist-eksportert": "Sist eksportert",
      "fil-sist-eksportert-aldri": "Ikke eksportert",
      "avtaleperiode-utgått": "Avtaleperioden er utgått. Nye bestillinger vil få en ny avtaleperiode.",
      "nye-endringer": "Nye endringer",
      "nye-endringer-aria-label": "Vis hjelpetekst til nye endringer",
      "nye-endringer-hjelpetekst": "Oversikt over endringer i antall bestillinger og avbestillinger. Sørg for å laste ned siste versjon av fil for å være helt oppdatert.",
      "bestillinger": "Bestillinger",
      "avbestillinger": "Avbestillinger",
      "ingen-endringer-siden-sist": "Ingen endringer siden sist eksport"
    },
    "kjøreplaner": {
      "tittel": "Frister for levering av målerdata",
      "beskrivelse": "Her finner du en oversikt over fristene for levering av målerdata. Oppgjøret kjøres dagen etter fristen. Vennligst merk at disse datoene kan endres, og at det vil ta inntil 15. virkedager fra oppgjøret starter til eventuelle utbetalinger kommer på konto.",
      "frist": "{{dato}} kl. {{klokkeslett}}",
      "åpne-kjøreplaner-dialog": "Vis plan for oppgjør"
    },
    "separate-oppgjor": {
      "beskrivelse": "Fra og med 1. september 2026 avregnes ikke innbetalinger og utbetalinger mot hverandre lenger. Hver utbetaling og hvert innbetalingskrav håndteres som en egen transaksjon, både for Norgespris og for strømstønad. Det betyr at dere kan få flere transaksjoner for samme oppgjør.",
      "les-mer": "Les mer om separate innbetalinger og utbetalinger"
    },
    "maaledata-periode": {
      "feil": {
        "fant-ikke-periode": "Fant ikke periode {{context}}, gå tilbake",
        "tilbake-link": "målerdata oversikt.",
        "laste-feil": "Det oppstod en feil ved lasting av periode. Vennligst prøv igjen senere."
      },
      "tittel": "Målerdata for {{context}}",
      "grunnlag": {
        "tittel": "Grunnlag for oppgjør",
        "valideringsFeil": {
          "tittel": "Valideringsfeil",
          "melding": "Vennligst korriger fil og last opp på nytt."
        },
        "last-opp": "Last opp målerdata",
        "erstatt-fil": "Erstatt fil",
        "laster-opp-fil": "Laster opp fil...",
        "lastet-opp": "Lastet opp",
        "last-ned": "Last ned",
        "ingen-fil-valgt": "Ingen fil valgt",
        "lastet-opp-suksess": "Filen er lastet opp",
        "tekniske-problem": {
          "tittel": "Tekniske problemer ved opplasting?",
          "beskrivelse": "Hvis veiledningen ikke strekker til, kan du kontakte oss på: ",
          "veileder": "Prøv vår veileder"
        },
        "innrapporteringsFrister": {
          "tittel": "Frister",
          "målerdata-låst": "Målerdata er lastet opp og behandlet!",
          "oppgjør-allerede-kjørt": "Oppgjør er allerede kjørt for denne perioden, så denne opplastingen vil bli med på neste kjøring {{context}}.",
          "ingen-neste-kjøreplan": "ikke fastsatt",
          "frist-mangler": "Opplasting av målerdata skal normalt gjøres innen 8. virkedag påfølgende måned. Vi jobber med å publisere eksakte frister for denne måneded.",
          "ekstraordinære-frister": "Ekstraordinært for {{periode}}:\nDet blir kjørt en ekstra runde med oppgjør følgende dato(er): {{frister}}.",
          "om-frist": "Opplasting av målerdata skal gjennomføres innen {{context}}.\nOpplasting etter denne fristen medfører at utbetalinger først vil bli behandlet i påfølgende periode.\n\nMålerdata kan endres frem til og med {{context}}."
        },
        "aapne-veiledning": "Les mer om frister"
      },
      "oppsummering": {
        "tittel": "Oppsummering",
        "sist-endret": "Sist endret: {{context}}",
        "totalt-forbruk": "Totalt forbruk",
        "stønadsberettiget-andel": "Stønadsberettiget andel",
        "antall-kunder": "Antall kunder",
        "norgespriskunder": "Norgespriskunder",
        "strømstønadskunder": "Strømstønadskunder",
        "norgespris-oppgjør-tittel": "Norgespris",
        "strømstønad-oppgjør-tittel": "Strømstønad",
        "grunnlag": "Grunnlag",
        "utbetalingsdato": "Utbetalingsdato",
        "ubetalingsdato-ikkesatt": "-",
        "betalingsreferanse": "Betalingsreferanse",
        "betalingsreferanse-ikkesatt": "-",
        "oppgjørstype": "{{context}}",
        "oppgjørstype_Innbetaling": "Til innbetaling",
        "oppgjørstype_Utbetaling": "Til utbetaling",
        "oppgjørstype_NullOppgjør": "Ingen betaling",
        "oppgjør_innlesningsType": "",
        "oppgjør_innlesningsType_Etterrapportering": "Etterrapportering",
        "oppgjør_innlesningsType_Korreksjon": "Korreksjon",
        "oppgjør_status_label": "Status",
        "oppgjørStatus": "-",
        "oppgjørStatus_Kalkulert": "Under behandling",
        "oppgjørStatus_UnderBehandling": "Under behandling",
        "oppgjørStatus_SendtTilØkonomisystem": "Under behandling",
        "oppgjørStatus_Fakturert": "Fakturert",
        "oppgjørStatus_Utbetalt": "Utbetalt",
        "oppgjørStatus_Innbetalt": "Innbetalt",
        "oppgjørStatus_Purring": "Purring",
        "oppgjørStatus_Inkasso": "Inkasso",
        "korreksjoner_tittel": "Korreksjoner og etterrapportering",
        "hjelpMva": "Utbetalingen er en stønadsutbetaling, ikke mva-pliktig omsetning, men den dekker likevel mva. dere har lagt ut for kundene.",
        "mvaBeløp": "(mva. 0 kr)"
      },
      "periode": "Perioden: ",
      "ikke-lastet-opp-data": "Ingen målerdata funnet."
    },
    "maalerdata-perioder": {
      "tittel": "Målerdata",
      "beskrivelse": "Denne siden viser en oversikt over alle periodene med målerdata som er mulig å registere.",
      "under-behandling-tekst": "Målerdata er behandlet, det kan ta flere dager før dere mottar oppgjøret.",
      "statuser": {
        "opplastet": "Opplastet",
        "låst": "Behandlet",
        "ingen-registrert": "Ingen målerdata registrert"
      },
      "laste-feil": "Det oppstod en feil ved lasting av selskaper. Vennligst prøv igjen senere.",
      "ingen-perioder": "Ingen perioder tilgjengelig.",
      "feil": "Noe feil har skjedd, vennligst prøv igjen senere."
    },
    "fjern-avtaler": {
      "statuser": {
        "avtaleStatus": "{{context}}",
        "avtaleStatus_Aktiv": "Aktiv",
        "avtaleStatus_Avbestilt": "Avbestilt",
        "avtaleStatus_Utgått": "Utgått",
        "avtaleStatus_Ugyldig": "Avtale kansellert",
        "ugyldigAvtaleÅrsak": "{{context}}",
        "ugyldigAvtaleÅrsak_Annet": "Annet",
        "ugyldigAvtaleÅrsak_IngenKundeForhold": "Ingen kundeforhold"
      },
      "tittel": "Fjern ugyldig avtale",
      "beskrivelse1": "Her kan du søke etter avtaler du ønsker å fjerne fra dine Norgesprisavtaler.",
      "beskrivelse2": "Dette kan være for eksempel manglende kundeforhold eller at kunde ikke oppfyller kravene til å få Norgespris.",
      "link": {
        "tittel": "Fjern ugyldige avtaler",
        "beskrivelse": "Her kan du avslutte en Norgesprisavtale. Dette kan være for eksempel manglende kundeforhold eller at kunde ikke oppfyller kravene til å få Norgespris.",
        "link": "Fjern ugyldig avtale"
      },
      "form": {
        "søk-tittel": "Søk etter avtaler",
        "søk-label": "Hvem søker du etter?",
        "søk-beskrivelse": "Søk på kundenummer, avtaleId eller navn på bestiller.",
        "tittel": "Søkeresultat",
        "ugyldig-tag": "Markert som ugyldig",
        "ingen-avtale": "Ingen avtale valgt",
        "innsender": "Innsender ({{navn}})",
        "bestillingstidspunkt": "Bestillingstidspunkt: {{date}}",
        "avtaleId": "Avtale id",
        "avtaleperiode": "Avtaleperiode",
        "kundenummer": "Kundenummer",
        "type-bolig": "Type bolig",
        "målepunkt-id": "Målepunkt-ID",
        "målepunkt-id-ikke-satt": "Ikke definert",
        "adresse": "Addresse",
        "velg-årsak": "Velg årsak for fjerning",
        "melding-til-bruker": "Melding som vises til bruker",
        "melding-til-bruker-beskrivelse": "Forslag til melding. Du kan endre eller legge til din egen tekst til brukeren",
        "melding-til-bruker-forslag": "Hei, du har registrert avtale på feil selskap, du har ingen kundeforhold hos oss. \nMvh {{navn}}",
        "tegn-igjen": "Du har {{antall}} tegn igjen.",
        "bekreft-fjerning": "Bekreft fjerning av avtale",
        "bekreft-checkbox": "Jeg bekrefter fjerning av Norgesprisavtale",
        "bekreft-required": "Du må huke av bekreft fjerning av Norgesprisavtale for å gå videre.",
        "fjern-avtale-knapp": "Fjern kundeavtale",
        "toast": {
          "feil": "Noe feil har skjedd, vennligst prøv igjen senere.",
          "lagret": "Avtalen er markert som ugyldig."
        }
      }
    },
    "validering": {
      "tittel": "Test fil med målerdata",
      "tag": "Testområde",
      "test-oppsummering": "Test oppsummering",
      "description": "Test filformat og stønadsbeløp basert på valgt spotpris. Du kan ikke bruke dette verktøyet til å teste korreksjoner eller innrapportering av flere perioder. Ingen målerdata blir lagret i dette området. Dette er kun for å teste og kontrollere at .CSV fil er korrekt eller inneholder feil.",
      "lenke-description": "Er du usikker om du har fått målerdata korrekt i .CSV fil, kan du sjekke fil for eventuelle feil og verdier.",
      "spottpris-label": "Angi en månedlig gjennomsnittlig spotpris (uten mva) du vil bruke som grunnlag",
      "opplasting-ok": "{{context}} inneholder ingen feil",
      "opplasting-feil": "{{context}} inneholder feil",
      "opplasting-feil_opplasting": "Feil ved opplasting av fil. Prøv på nytt.",
      "last-opp-knapp": "Last opp CSV fil",
      "last-opp-fil": "Last opp fil",
      "laster-opp-fil": "Laster opp fil...",
      "lastet-opp-suksess": "Filen er gyldig",
      "valideringsfeil-melding": "Vennligst korriger fil og last opp på nytt.",
      "link": "Gå til testområde"
    },
    "simulering": {
      "tittel": "Simuler opplasting av målerdata",
      "tag": "Simulering",
      "test-oppsummering": "Test oppsummering",
      "description": "Her kan du simulere en opplasting basert på reelle verdier, inklusive korreksjoner og etterrapportering fra tidligere perioder. Ingenting blir lagret i dette området. Verkøtyet tar utgangspunkt i opplasting for inneærende måned, dvs. at rader utenfor inneværende måned ansees som korreksjoner og etterrapporteringer.",
      "lenke-description": "Her kan du simulere en komplett opplasting, inklusive korreksjoner og etterfakturering",
      "opplasting-ok": "{{context}} inneholder ingen feil",
      "opplasting-feil": "{{context}} inneholder feil",
      "opplasting-feil_opplasting": "Feil ved opplasting av fil. Prøv på nytt.",
      "last-opp-knapp": "Last opp CSV fil",
      "last-opp-fil": "Last opp fil",
      "laster-opp-fil": "Laster opp fil...",
      "lastet-opp-suksess": "Filen er gyldig",
      "valideringsfeil-melding": "Vennligst korriger fil og last opp på nytt.",
      "link": "Gå til simulering"
    },
    "kundestotte": {
      "tittel": "Kundestøtte",
      "spoersmaal-om-regelverk": {
        "tittel": "Spørsmål om regelverket for Norgespris",
        "beskrivelse": "Har du spørsmål eller trenger mer informasjon om Norgespris og strømstøtte for fjernvarme. Kan du finne svar på NVE (Norges vassdrags- og energidirektorat) sine nettsider.",
        "lenke-mer-om-regelverket": "NVE - Spørsmål og svar til Norgespris og strømstøtte for fjernvarme",
        "lenke-om-norgespris": "NVE - Norgespris og strømstøtte for fjernvarme"
      },
      "spoersmaal-om-loesning": {
        "tittel": "Spørsmål til selskapsportalen",
        "beskrivelse": "Har du tekniske spørsmål om selskapsportalen for fjernvarme, kan du ta kontakt med Enova Svarer.",
        "lenke-kontakt-oss": "Enova - Kontakt oss"
      },
      "veiledning": {
        "tittel": "Veiledning for siden",
        "beskrivelse": "Hvis det er noe med nettsiden som er vanskelig å forstå eller man har problemer med selve løsningen, kan det lønne seg å sjekke veiledningene våre først",
        "lenke": "Veiledning for Selskapsportal for fjernvarme"
      }
    },
    "innstillinger": {
      "tittel": "Innstillinger",
      "beskrivelse": "Her kan du endre dine brukerinnstillinger.",
      "navn": "Navn",
      "organisasjonsnummer": "Organisasjonsnummer",
      "sist-endret-av": "Sist endret av",
      "form": {
        "feil": {
          "kontonummer": {
            "ugyldig": "Kontonummeret må være 11 siffer (format XXXX XX XXXXX).",
            "samme": "Kontonummeret for strømstønad kan ikke være det samme som kontonummer for Norgespris."
          },
          "epost": {
            "ugyldig": "Faktura epost må være en gyldig epost adresse."
          }
        },
        "tittel": "Aktør"
      },
      "toast": {
        "lagret": "Innstillingene ble lagret",
        "feil": "Lagring av innstillinger feilet, vennligst prøv igjen senere."
      },
      "felt": {
        "fakturaEpost": {
          "label": "Faktura epost",
          "hjelpetekst": "Mottak av eventuell faktura"
        },
        "norgesprisKontonummer": {
          "label": "Kontonummer for Norgespris",
          "hjelpetekst": "11 siffer, egen konto for Norgespris"
        },
        "stromstonadKontonummer": {
          "hjelpetekst": "11 siffer, egen konto for strømstønad",
          "label": "Kontonummer for strømstønad"
        }
      },
      "feil-ved-henting": {
        "tittel": "Det oppsto en feil ved henting av skjema",
        "beskrivelse": "Kunne ikke hente innstillinger."
      },
      "mangler": {
        "alt": "Legg til e-post og kontonummer",
        "varsel": "Vi mangler informasjon for {{selskap}} for å utføre utbetalinger. ",
        "lenke": "Gå til innstillinger"
      }
    },
    "veiledning": {
      "tittel": "Veiledning",
      "beskrivelse": "På denne siden finner du løsningen på de vanligste spørsmålene og problemene som kan oppstå.",
      "lenke-beskrivelse": "Hvordan eksportere bestillinger og innrapportere målerdata.",
      "lenke-tekst": "Gå til veileder"
    },
    "maanedsplan-frister": {
      "tittel": "Månedsplan for oppgjør i 2026",
      "beskrivelse": "Virkedager er eksklusiv helger og offentlige fridager. Betaling kan både være innbetaling eller utbetaling. Det vil bli sendt ut faktura ved innbetaling. Utbetalinger skjer til konto oppgitt i innstillinger.",
      "01-priser": {
        "tittel": "1. Virkedag - Kl. 12:00",
        "hva": "Publisering av referansepriser",
        "hvem": "Ansvarlig: NVE"
      },
      "02-innrapportering": {
        "tittel": "8. Virkedag - kl. 12:00",
        "hva": "Innrapportering av målerdata og stønadsbeløp til Enova",
        "hvem": "Ansvarlig: Fjernvarmeleverandører"
      },
      "03-faktura": {
        "tittel": "9. Virkedag – kl.12:00",
        "hva": "Oppgjør/faktura",
        "hvem": "Månedsspot > 40 øre: Enova generer oppgjør for Norgespris og Strømstøtte ut fra innrapporterte data.\n\nMånedsspot<40 øre: Enova sender ut faktura for oppgjør Norgespris\n\nAnsvarlig: Enova"
      },
      "04-betaling": {
        "tittel": "24. Virkedag - kl. 23:59",
        "hva": "Betalingsfrist\nAnsvarlig for betaling",
        "hvem": "Månedsspot > 40 øre: Enova\n\nMånedsspot<40 øre: Fjernvarmeleverandører"
      }
    }
  },
  "password-protection": {
    "tittel": "Passordbeskyttelse",
    "beskrivelse": "Innlogging er bare åpnet for personer som skal teste løsningen. Gå tilbake til forsiden for å lese mer om når Norgespris for fjernvarme blir tilgjenglig for alle.",
    "neste": "Neste",
    "tilbake": "Tilbake til forsiden",
    "passord": {
      "label": "Passord",
      "placeholder": "Skriv inn passord"
    },
    "feil": {
      "ugyldig-passord": "Ugyldig passord. Vennligst prøv igjen.",
      "passord-pakrevd": "Passord er påkrevd for å fortsette."
    }
  },
  "feilmelding": {
    "overskrift": "Det oppstod en feil",
    "overskrift_404": "Fant ikke siden",
    "beskrivelse": "Vennligst prøv igjen ved et senere tidspunkt.",
    "beskrivelse_404": "Siden du prøvde å nå finnes ikke.\nKanskje har du skrevet inn en feil adresse, eller så er siden flyttet.",
    "beskrivelse_10001": "Vennligst prøv igjen ved et senere tidspunkt.",
    "prøv-igjen": "Prøv å last siden på nytt"
  },
  "toaster": {
    "lukk": "Lukk varsel"
  },
  "callback": {
    "logger-inn": "Logger inn",
    "venter": "Vennligst vent mens vi fullfører innloggingen."
  },
  "header": {
    "handlinger": {
      "velg-aktoer": "Velg selskap",
      "innstillinger": "Innstillinger",
      "logg-ut": "Logg ut"
    }
  },
  "skjema": {
    "feil-oppsummering": "For å gå videre må du rette opp følgende feil"
  }
}
